import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { GoalShape } from 'entities';
import Goals from 'containers/Goals';
import InfoBar from 'components/InfoBar';
import NoEntries from 'components/NoEntries';
import NoEntriesDetail from 'components/NoEntries/NoEntriesDetail';

import UserGoalsLoading from './UserGoalsLoading';
import UserGoalsAddGoal from './UserGoalsAddGoal';

import * as actions from 'actions';
import { getGoals, getGoalsFetching, getInfoState } from 'selectors';

import './style.scss';

class UserGoals extends Component {

  componentDidMount() {
    this.props.onDidMount();
  }

  render() {
    return (
      <section className="UserGoals content-wrapper has-background">
        {this.props.isSuccessInfoBarVisible && <InfoBar isStatic type="primary" title={this.props.successInfoBarTitle} message={this.props.successInfoBarMessage} />}

        <UserGoalsAddGoal />

        <div className="content">
          <div className="wrapper-small is-collapsed">
            {(() => {
              if(this.props.goals.length > 0) {
                return (
                  <Goals goals={this.props.goals} source={process.env.KOOTH_USER_GOALS}/>
                );
              }
              else if(this.props.isFetching) {
                return <UserGoalsLoading />;
              }
              else {
                return (
                  <NoEntries title={__('members.goals.noEntries.title')}>
                    <NoEntriesDetail>{__('members.goals.noEntries.subtitle')}</NoEntriesDetail>
                    <NoEntriesDetail>{__('members.goals.noEntries.text')}</NoEntriesDetail>
                  </NoEntries>
                );
              }
            })()}
          </div>
        </div>
      </section>
    );
  }
}

UserGoals.propTypes = {
  goals: PropTypes.arrayOf(GoalShape),
  isFetching: PropTypes.bool,
  onDidMount: PropTypes.func,
  isSuccessInfoBarVisible: PropTypes.bool,
  successInfoBarMessage: PropTypes.string,
  successInfoBarTitle: PropTypes.string
};

const mapStateToProps = state => {
  const successState = getInfoState(state, 'success');
  const isSuccessInfoBarVisible = successState.visible;
  const successInfoBarMessage = successState.message;
  const successInfoBarTitle = successState.title;

  return {
    isSuccessInfoBarVisible,
    successInfoBarMessage,
    successInfoBarTitle,
    goals: getGoals(state),
    isFetching: getGoalsFetching(state).isFetching
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onDidMount: () => {
      dispatch(actions.goalsFetch({
        offset: 0,
        limit: process.env.KOOTH_MAX_GOALS
      }));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserGoals);



/** WEBPACK FOOTER **
 ** ./src/members/Main/UserGoals/index.js
 **/